import { Injectable } from '@angular/core';
import { GlobalStoreService } from '@principle-theorem/ng-principle-shared';
import {
  FeeScheduleManager,
  PricedServiceCodeEntry,
} from '@principle-theorem/principle-core';
import {
  type IChartedTreatment,
  type IFeeSchedule,
  type IPricedServiceCodeEntry,
  type IServiceCode,
} from '@principle-theorem/principle-core/interfaces';
import { type WithRef, snapshot } from '@principle-theorem/shared';
import { type Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';

@Injectable()
export class ServiceCodeManagerService {
  constructor(private _globalStore: GlobalStoreService) {}

  async addServiceCodeWithFeeSchedule(
    treatmentServiceCodes: IPricedServiceCodeEntry[],
    stepServiceCodes: IPricedServiceCodeEntry[],
    serviceCode: IServiceCode,
    treatment: IChartedTreatment,
    feeSchedule$: Observable<WithRef<IFeeSchedule>>
  ): Promise<IPricedServiceCodeEntry[]> {
    const feeSchedule = await snapshot(
      feeSchedule$.pipe(
        switchMap((schedule) => this._globalStore.getFeeSchedule$(schedule.ref))
      )
    );

    const manager = await FeeScheduleManager.create(feeSchedule.ref);
    const entry = this._createPricedServiceCodeEntry(serviceCode, treatment);

    return [
      ...treatmentServiceCodes,
      PricedServiceCodeEntry.applyFeeSchedule(
        entry,
        [...stepServiceCodes, entry],
        manager,
        false
      ),
    ];
  }

  private _createPricedServiceCodeEntry(
    serviceCode: IServiceCode,
    treatment: IChartedTreatment
  ): IPricedServiceCodeEntry {
    return PricedServiceCodeEntry.init({
      code: serviceCode.code,
      type: serviceCode.type,
      taxStatus: serviceCode.taxStatus,
      chartedItemOrigin: treatment.config,
      chartedSurfaces: treatment.chartedSurfaces,
      extendedData: serviceCode.extendedData,
    });
  }
}
